import { endOfWeek, startOfWeek } from "date-fns";

export const getFirstDateOfWeek = (
  date: Date,
  weekStartsOn: "sunday" | "monday"
) => {
  return startOfWeek(date, { weekStartsOn: weekStartsOn === "sunday" ? 0 : 1 });
};

export const getLastDateOfWeek = (
  date: Date,
  weekStartsOn: "sunday" | "monday"
) => {
  return endOfWeek(date, { weekStartsOn: weekStartsOn === "sunday" ? 0 : 1 });
};
